module.exports = __webpack_public_path__ + "img/icon_map_2_off_001.22b8bdeb.png";